import './treatmentTypeGalleryHeader.scss';

import { IonSlide, useIonViewWillEnter } from '@ionic/react';
import defaultPicture from 'application/pages/Treatments/images/treatment-default-picture.jpg';
import type { TreatmentTypeMedia, WithMedia } from 'application/types';
import * as React from 'react';
import { useContextTranslation } from 'ui/translation';

import SwiperWithNavigation from './SwiperWithNavigation/SwiperWithNavigation';

interface TreatmentTypeGalleryHeaderProps {
  type: WithMedia & { id: string } | null;
  small?: boolean;
  single?: boolean;
}

const SLIDER_OPTIONS = {
  touchReleaseOnEdges: true,
  longSwipes: false,
  preloadImages: true,
};

const defaultMedia: TreatmentTypeMedia[] = [
  {
    type: 'video',
    uri: '/treatment-default-video.mp4',
  },
  {
    type: 'image',
    uri: defaultPicture,
  },
];

const TreatmentTypeGalleryHeader: React.FC<TreatmentTypeGalleryHeaderProps> = ({
  type,
  small,
  single,
}) => {
  const t = useContextTranslation('misc');
  const ref = React.useRef<HTMLIonSlidesElement>(null);
  const slider = React.useRef<HTMLIonSlidesElement>(null);

  useIonViewWillEnter(() => {
    if (ref.current) {
      ref.current.update().catch(() => {});
    }
  });

  const media = type ? type.media : defaultMedia;
  const displayedMedia = small || single ? media.slice(0, 1) : media;
  return (
    <div className={`treatment-type-gallery-header${small ? ' small' : ''}`}>
      <SwiperWithNavigation
        slider={slider}
        key={type?.id || 'default_slides'}
        options={SLIDER_OPTIONS}
      >
        {displayedMedia.map(mediaItem => (
          <IonSlide key={mediaItem.uri}>
            {mediaItem.type === 'video' ? (
              <video
                className={!type ? 'default-video' : ''}
                playsInline
                controls={false}
                src={mediaItem.uri}
                muted
                autoPlay
                loop
              />
            ) : (
              <img src={mediaItem.uri} alt={t('media')} />
            )}
          </IonSlide>
        ))}
      </SwiperWithNavigation>
    </div>
  );
};

export default TreatmentTypeGalleryHeader;
